/**
 * IDs for dashboard global-parameter DnD: param::{barId}::{parameterName}
 * (barId and param name must not contain "::".)
 */
export function parseDashboardParamDragId(id) {
  const s = String(id);
  const PREFIX = "param::";
  if (!s.startsWith(PREFIX)) {
    return null;
  }
  const rest = s.slice(PREFIX.length);
  const sep = rest.indexOf("::");
  if (sep === -1) {
    return null;
  }
  return {
    barId: rest.slice(0, sep),
    paramName: rest.slice(sep + 2),
  };
}

export function dashboardParamDragId(barId, paramName) {
  return `param::${barId}::${paramName}`;
}

/** Same fragments as legacy Parameters.jsx reads from hide_filter=. */
export function dashGlobalHideFragmentsFromLocation() {
  const hideRegex = /hide_filter=([^&]+)/g;
  return Array.from(window.location.search.matchAll(hideRegex), match => match[1]);
}

function toCamelCase(str) {
  if (!str) {
    return "";
  }
  return str.replace(/\s+/g, "").toLowerCase();
}

/** Mirrors Parameters.jsx shouldRender hiding for global dashboard rows. */
export function isDashboardGlobalParameterRowVisible(parameter, hideFragments) {
  if (hideFragments.some(value => toCamelCase(value) === toCamelCase(parameter.name))) {
    return false;
  }
  if (parameter.hidden) {
    return false;
  }
  return true;
}

/** IDs passed to SortableContext must match rendered sortable rows. */
export function sortableDashboardParamDragIdsForBar(barId, parameters, hideFragments) {
  const frags = hideFragments || dashGlobalHideFragmentsFromLocation();
  return parameters
    .filter(param => isDashboardGlobalParameterRowVisible(param, frags))
    .map(param => dashboardParamDragId(barId, param.name));
}

